export default __webpack_public_path__ + "static/media/VTorpedoOpen.75bc971c.jpg";